import { render, staticRenderFns } from "./fertilizerManagement.vue?vue&type=template&id=2bb73d18&scoped=true"
import script from "./fertilizerManagement.vue?vue&type=script&lang=js"
export * from "./fertilizerManagement.vue?vue&type=script&lang=js"
import style0 from "./fertilizerManagement.vue?vue&type=style&index=0&id=2bb73d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb73d18",
  null
  
)

export default component.exports